<template>
  <div>
    <button type="button" class="btn btn-danger flex-item" @click="show = true">
      <em class="fa fa-backward"/>
      Reject
    </button>
    <modal :show="show" :close="hide" title="Reject" hide-footer>
      <design-reject-form :value="value" @input="hide(); $emit('success', $event)"/>
    </modal>
  </div>
</template>

<script>
import DesignAssignForm from "@/components/Views/Design/DesignAssignForm";
import Modal from "@/components/Misc/Modal";
import DesignRejectForm from "@/components/Views/Design/DesignRejectForm";

export default {
  name: "DesignRejectButton",
  components: {DesignRejectForm, Modal, DesignAssignForm},
  props: {value: Object},
  data() {
    return {
      show: false
    }
  },
  methods: {
    hide() {
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>